import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiBaseService {
  url = environment.apiPath;
  constructor(public http: HttpClient) {}

  get(endpoint: string, params?: any, reqOpts?: any): Observable<any> {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams(),
      };
    }

    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();

      for (const k in params) {
        if (k in params) {
          reqOpts.params = reqOpts.params.set(k, params[k]);
        }
      }
    }
    return this.http.get(this.url + '/' + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any): Observable<any> {
    return this.http
      .post(this.url + '/' + endpoint, body, reqOpts)
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  put(endpoint: string, body: any, reqOpts?: any): Observable<ArrayBuffer> {
    return this.http.put(this.url + '/' + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any): Observable<ArrayBuffer> {
    // console.log(this.url + '/' + endpoint, reqOpts);
    console.log(this.url + '/' + endpoint, reqOpts);
    return this.http.delete(this.url + '/' + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any): Observable<ArrayBuffer> {
    return this.http.patch(this.url + '/' + endpoint, body, reqOpts);
  }

  uploadfileAWSS3(
    fileuploadurl,
    contenttype,
    file,
    contentDisposition = true,
  ): Observable<any> {
    const header = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': contenttype,
    };

    if (contentDisposition) {
      header['Content-Disposition'] = 'attachment';
    }

    const headers = new HttpHeaders(header);
    const req = new HttpRequest('PUT', fileuploadurl, file, {
      headers: headers,
    });

    console.log('headers: ', headers);

    return this.http.request(req);
  }
}
